import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {IEmoji} from "@/types/IEmoji";

let initialState: IEmoji[] = [{
    id:0,
    unicode: "",
    hidden: 0,
    group: ""
}];

export const EmojiSlice = createSlice({
    name: "step_slice",
    initialState,
    reducers: {
        setEmojis: (state, action: PayloadAction<IEmoji[]>) => {
            state = action.payload
            return state;
        },
    },
});

export const { setEmojis } = EmojiSlice.actions;

export default EmojiSlice.reducer;